import { RequirementDataService } from "../../core/requirements.dataservice";
import { RequirementSectionDataService } from "../../core/requirementsections.dataservice";
import { AuthorityDataService } from "../../core/authorities.dataservice";
import { CompetenceTypeDataService } from "../../core/competencetypes.dataservice";
import { RoleTypeDataService } from "../../core/jobroletypes.dataservice";
import { ActivityTypeDataService } from "../../core/activitytypes.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { Requirements } from "./requirements.component";
import { EditRequirement } from "./requirement.edit.component";
import { Requirement } from "./requirement.component";
import { CompetenceGroupsService } from "../../core/competencegroups.dataservice";

/**
 * This state displays all Requirements
 */
export const requirementsState: Ng2StateDeclaration = {
    name: "app.settings.requirements",
    url: "/requirements",
    views: {
        "main-view@app": {
            component: Requirements
        }
    },
    resolve: {
        requirements: [RequirementDataService.Id, (requirementDataService: RequirementDataService) => {
            return requirementDataService.getAll();
        }],
        requirementSections: [RequirementSectionDataService.Id, (requirementSectionDataService: RequirementSectionDataService) => {
            return requirementSectionDataService.getAll();
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Requirement
 */
export const newRequirementState: Ng2StateDeclaration = {
    name: "app.settings.requirements.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditRequirement
        }
    },
    resolve: {
        requirement: function () {
            return <Nema.Crew.Model.CompetenceRequirement>{
                Id: -1,
                Name: "",
                SortTag: "",
                Description: "",
                CompetenceRequirementActivityTypes: [],
                CompetenceRequirementCompetenceTypes: [],
                CompetenceRequirementRoleTypes: [],
                NrPersons: 1
            };
        },
        requirementSections: [RequirementSectionDataService.Id, (requirementSectionDataService: RequirementSectionDataService) => {
            return requirementSectionDataService.getAll();
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        competenceGroups: [CompetenceGroupsService.Id, (competenceGroupsService: CompetenceGroupsService) => {
            return competenceGroupsService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, (competenceTypeDataService: CompetenceTypeDataService) => {
            return competenceTypeDataService.getAll();
        }],
        activityTypes: [ActivityTypeDataService.Id, (activityTypeDataService: ActivityTypeDataService) => {
            return activityTypeDataService.getAll();
        }],
        roleTypes: [RoleTypeDataService.Id, (roleTypeDataService: RoleTypeDataService) => {
            return roleTypeDataService.getAll();
        }],
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Requirement
 */
export const editRequirementState: Ng2StateDeclaration = {
    name: "app.settings.requirements.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditRequirement
        }
    },
    resolve: {
        requirement: [RequirementDataService.Id, "$stateParams", function (requirementDataService: RequirementDataService, $stateParams) {
            return requirementDataService.get($stateParams.id);
        }],
        requirementSections: [RequirementSectionDataService.Id, (requirementSectionDataService: RequirementSectionDataService) => {
            return requirementSectionDataService.getAll();
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        competenceGroups: [CompetenceGroupsService.Id, (competenceGroupsService: CompetenceGroupsService) => {
            return competenceGroupsService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, (competenceTypeDataService: CompetenceTypeDataService) => {
            return competenceTypeDataService.getAll();
        }],
        activityTypes: [ActivityTypeDataService.Id, (activityTypeDataService: ActivityTypeDataService) => {
            return activityTypeDataService.getAll();
        }],
        roleTypes: [RoleTypeDataService.Id, (roleTypeDataService: RoleTypeDataService) => {
            return roleTypeDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Requirement Details state
 */
export const requirementState: Ng2StateDeclaration = {
    name: "app.settings.requirements.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: Requirement
        }
    },
    resolve: {
        requirement: [RequirementDataService.Id, "$stateParams", function (requirementDataService: RequirementDataService, $stateParams) {
            return requirementDataService.get($stateParams.id);
        }],
        requirementSections: [RequirementSectionDataService.Id, (requirementSectionDataService: RequirementSectionDataService) => {
            return requirementSectionDataService.getAll();
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        competenceTypes: [CompetenceTypeDataService.Id, (competenceTypeDataService: CompetenceTypeDataService) => {
            return competenceTypeDataService.getAll();
        }],
        activityTypes: [ActivityTypeDataService.Id, (activityTypeDataService: ActivityTypeDataService) => {
            return activityTypeDataService.getAll();
        }],
        roleTypes: [RoleTypeDataService.Id, (roleTypeDataService: RoleTypeDataService) => {
            return roleTypeDataService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirements/requirements.states.ts